/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import {
  CreateLabelResponseData,
  CreateLabelResponseDataFromJSON,
  CreateLabelResponseDataFromJSONTyped,
  CreateLabelResponseDataToJSON
} from './CreateLabelResponseData'

/**
 *
 * @export
 * @interface UpdateLabelResponse
 */
export interface UpdateLabelResponse {
  /**
   *
   * @type {number}
   * @memberof UpdateLabelResponse
   */
  status?: number
  /**
   *
   * @type {CreateLabelResponseData}
   * @memberof UpdateLabelResponse
   */
  data?: CreateLabelResponseData
}

export function UpdateLabelResponseFromJSON(json: any): UpdateLabelResponse {
  return UpdateLabelResponseFromJSONTyped(json, false)
}

export function UpdateLabelResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateLabelResponse {
  if (json === undefined || json === null) {
    return json
  }
  return {
    status: !exists(json, 'status') ? undefined : json['status'],
    data: !exists(json, 'data') ? undefined : CreateLabelResponseDataFromJSON(json['data'])
  }
}

export function UpdateLabelResponseToJSON(value?: UpdateLabelResponse | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    status: value.status,
    data: CreateLabelResponseDataToJSON(value.data)
  }
}
